import TrebbleCard from "../../../../common/TrebbleCard";
import TrebbleButton from "../../../../common/TrebbleButton";

import { CaptionTemplate } from "./CaptionTemplate";
import { BrandSystemConfig } from "../../../remotion/Components/Theme/Brand";
import { SavedCaptionDesignSystemConfig } from "../../../remotion/Components/Captions/Caption";
import ti18n from 'i18n!nls/ClipCreatori18n'; // Import i18n

// Extend Window interface if not already done globally
declare global {
    interface Window {
      getI18n: (i18nData: any, key: string, options?: any) => string;
    }
  }

interface CaptionListProps {
    userCaptions: SavedCaptionDesignSystemConfig[];
    trebbleCaptionsByCategory: { [key: string]: SavedCaptionDesignSystemConfig[] };
    selectedCaption: SavedCaptionDesignSystemConfig | undefined;
    selectedCaptionDetails: SavedCaptionDesignSystemConfig | undefined;
    brandConfig: BrandSystemConfig;
    onCaptionSelect: (caption: SavedCaptionDesignSystemConfig) => void;
    onEdit: () => void;
    onDuplicate: () => void;
    showActions?: boolean;
}

export const CaptionList = ({
    userCaptions,
    trebbleCaptionsByCategory,
    selectedCaption,
    selectedCaptionDetails,
    brandConfig,
    onCaptionSelect,
    onEdit,
    onDuplicate,
    showActions = true
}: CaptionListProps) => {
    const hasUserCaptions = userCaptions?.filter(Boolean).length > 0;

    return (
        <div className="flex flex-col">
            {hasUserCaptions && (
                <>
                    <div className="sticky top-0 z-10 bg-white dark:bg-neutral-800 dark:text-white mt-4 border-x border-t border-neutral-100 dark:border-neutral-600">
                        <h2 className="py-3 px-3 font-bold">{window.getI18n(ti18n, "YOUR_CAPTIONS_SECTION_TITLE").toUpperCase()}</h2>
                    </div>
                    <TrebbleCard size="small">
                        <div className="flex flex-col gap-2">
                            {userCaptions?.filter(Boolean).map(caption => (
                                <CaptionTemplate
                                    key={caption.id}
                                    caption={caption}
                                    brandConfig={brandConfig}
                                    onClick={() => onCaptionSelect(caption)}
                                    selected={caption.id === selectedCaption?.id}
                                />
                            ))}
                        </div>
                    </TrebbleCard>
                </>
            )}

            {/* Caption Categories */}
            {Object.entries(trebbleCaptionsByCategory).map(([category, captions]) => (
                <div key={category}>
                    <div className="sticky top-0 z-10 bg-white dark:bg-neutral-800 dark:text-white mt-4 border-x border-t border-neutral-100 dark:border-neutral-600" >
                        <h2 className="py-3 px-3 font-bold">{category.toUpperCase()}</h2>
                    </div>
                    <TrebbleCard size="small">
                        <div className="flex flex-col gap-2">
                            {captions.map(caption => (
                                <CaptionTemplate
                                    key={caption.id}
                                    caption={caption}
                                    brandConfig={brandConfig}
                                    onClick={() => onCaptionSelect(caption)}
                                    selected={caption.id === selectedCaption?.id}
                                />
                            ))}
                        </div>
                    </TrebbleCard>
                </div>
            ))}

            {/* Fixed Bottom Bar - Only show when captions are displayed and showActions is true */}
            {showActions && (
                <div className="sticky bottom-0 bg-white border-t p-4 mt-4 z-20 dark:bg-neutral-800 dark:border-neutral-600">
                    <div className="flex gap-2">
                        <TrebbleButton 
                            block 
                            disabled={!selectedCaptionDetails || (selectedCaptionDetails?.type === 'trebble')}
                            onClick={onEdit}
                        >
                            {window.getI18n(ti18n, "EDIT_BUTTON")}
                        </TrebbleButton>
                        <TrebbleButton 
                            block 
                            type="primary" 
                            disabled={!selectedCaptionDetails} 
                            onClick={onDuplicate}
                        >
                            {window.getI18n(ti18n, "DUPLICATE_BUTTON")}
                        </TrebbleButton>
                    </div>
                </div>
            )}
        </div>
    );
}; 